// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// GSAP Plugins
// gsap.registerPlugin(ScrollTrigger);

export default {
    init() {
        // console.log('HOMEPAGE INIT');

        // Homepage MAIN SLIDER
        const homepageSlider = new Swiper("#homepage-slider", {
            speed: 800,
            loop: true,
            effect: "fade",
            fadeEffect: { crossFade: true },
            virtualTranslate: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              // bullets with numbers
              // renderBullet: function (index, className) {
              //   return '<span class="' + className + '">' + (index + 1) + "</span>";
              // },
              // circle bullets
              renderBullet: function (index, className) {
                return '<span class="' + className + ' circle"></span>';
              },
            },
            navigation: {
              nextEl: "#main-slider-next",
              prevEl: "#main-slider-prev",
            },
        });

        // Homepage MOBILE DIETS SLIDER
        const dietsMobile = new Swiper("#diets-mobile", {
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 3,
          loop: true,
          speed: 800,
          autoplay: {
            delay: 3500,
            disableOnInteraction: false,
          },
          initialSlide: 1,
          coverflowEffect: {
            rotate: 1,
            stretch: -80,
            depth: 500,
            modifier: 1,
            slideShadows: false,
          },
          // hidden navigation
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });

        // Homepage RECOMMENDATIONS SLIDER
        var recommendationsSlider = new Swiper("#recommendations-slider", {
          slidesPerView: 1,
          spaceBetween: 40,
          loop: true,
          navigation: {
            nextEl: "#rec-button-next",
            prevEl: "#rec-button-prev",
          },
          breakpoints: {
            992: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1420: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
            1900: {
              slidesPerView: 4,
              spaceBetween: 120,
            },
          },
          autoplay: {
            delay: 3500,
            disableOnInteraction: false,
          },
        });

        // INTERAKTYWNY JADLOSPIS
        function initJadlospis() {
          const firstDiet = $('.single-diet-menu-btn');
          const firstDietId = firstDiet.attr('data-diet-id');
          $('#diet-btn-' + firstDietId).addClass('active');
          // $('#day-01-btn').addClass('active');
          // $('.poniedzialek').addClass('active');
          $('.dieta-menu-set[data-diet-id="' + firstDietId + '"]').addClass('active');
        }

        initJadlospis();

        // DIETY BUTTTONS
        $('.single-diet-menu-btn').click(function() {
          $('.single-diet-menu-btn').removeClass('active');
          $(this).addClass('active');

          const currentDietId = $(this).attr('data-diet-id');
          // console.log(currentDietId);

          $('.dieta-menu-set').removeClass('active');
          $('.dieta-menu-set[data-diet-id="' + currentDietId + '"]').addClass('active');
        });

        // TYGODNIE BUTTONS
        $('.przedzial-dat.current-week').click(function() {
          $('.przedzial-dat').removeClass('active');
          $(this).addClass('active');
          $('.day-btn').removeClass('active');
          $('.day-set').removeClass('active');
          $('.today').addClass('active');
          $('#sprawdz-nasze-menu').removeClass('next');
          $('#sprawdz-nasze-menu').addClass('current');
        });
        $('.przedzial-dat.next-week').click(function() {
          $('.przedzial-dat').removeClass('active');
          $(this).addClass('active');
          $('.day-btn').removeClass('active');
          $('.day-set').removeClass('active');
          $('.poniedzialek.next').addClass('active');
          $('#day-01-btn').addClass('active');
          $('#sprawdz-nasze-menu').removeClass('current');
          $('#sprawdz-nasze-menu').addClass('next');
        });

        // DNI TYGODNIA MENU
        $('#day-01-btn').click(function() {
          $('.day-btn').removeClass('active');
          $(this).addClass('active');
          if ($('#sprawdz-nasze-menu').hasClass('current')) {
            $('.day-set').removeClass('active');
            $('.day-set.poniedzialek.current').addClass('active');
          } else if($('#sprawdz-nasze-menu').hasClass('next')) {
            $('.day-set').removeClass('active');
            $('.day-set.poniedzialek.next').addClass('active');
          }
        });

        $('#day-02-btn').click(function() {
          $('.day-btn').removeClass('active');
          $(this).addClass('active');
          if ($('#sprawdz-nasze-menu').hasClass('current')) {
            $('.day-set').removeClass('active');
            $('.day-set.wtorek.current').addClass('active');
          } else if($('#sprawdz-nasze-menu').hasClass('next')) {
            $('.day-set').removeClass('active');
            $('.day-set.wtorek.next').addClass('active');
          }
        });

        $('#day-03-btn').click(function() {
          $('.day-btn').removeClass('active');
          $(this).addClass('active');
          if ($('#sprawdz-nasze-menu').hasClass('current')) {
            $('.day-set').removeClass('active');
            $('.day-set.sroda.current').addClass('active');
          } else if($('#sprawdz-nasze-menu').hasClass('next')) {
            $('.day-set').removeClass('active');
            $('.day-set.sroda.next').addClass('active');
          }
        });

        $('#day-04-btn').click(function() {
          $('.day-btn').removeClass('active');
          $(this).addClass('active');
          if ($('#sprawdz-nasze-menu').hasClass('current')) {
            $('.day-set').removeClass('active');
            $('.day-set.czwartek.current').addClass('active');
          } else if($('#sprawdz-nasze-menu').hasClass('next')) {
            $('.day-set').removeClass('active');
            $('.day-set.czwartek.next').addClass('active');
          }
        });

        $('#day-05-btn').click(function() {
          $('.day-btn').removeClass('active');
          $(this).addClass('active');
          if ($('#sprawdz-nasze-menu').hasClass('current')) {
            $('.day-set').removeClass('active');
            $('.day-set.piatek.current').addClass('active');
          } else if($('#sprawdz-nasze-menu').hasClass('next')) {
            $('.day-set').removeClass('active');
            $('.day-set.piatek.next').addClass('active');
          }
        });

        $('#day-06-btn').click(function() {
          $('.day-btn').removeClass('active');
          $(this).addClass('active');
          if ($('#sprawdz-nasze-menu').hasClass('current')) {
            $('.day-set').removeClass('active');
            $('.day-set.sobota.current').addClass('active');
          } else if($('#sprawdz-nasze-menu').hasClass('next')) {
            $('.day-set').removeClass('active');
            $('.day-set.sobota.next').addClass('active');
          }
        });

        $('#day-07-btn').click(function() {
          $('.day-btn').removeClass('active');
          $(this).addClass('active');
          if ($('#sprawdz-nasze-menu').hasClass('current')) {
            $('.day-set').removeClass('active');
            $('.day-set.niedziela.current').addClass('active');
          } else if($('#sprawdz-nasze-menu').hasClass('next')) {
            $('.day-set').removeClass('active');
            $('.day-set.niedziela.next').addClass('active');
          }
        });


      // TESTY INTEGRACJI API - MASTERLIFE
      // GET WEEK DATES AFTER FRIDAYS NOON
      // const today = new Date("January 4, 2022 23:15:00");
      const today = new Date();
      today.getDate();

      function getThisMonday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getThisTuesday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -5:2); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getThisWednesday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -4:3); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getThisThursday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -3:4); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getThisFriday(d) {
        d = new Date(d);
        const day = d.getDay();
        const diff = d.getDate() - day + (day == 0 ? -2:5); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getThisSaturday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -1:6); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getThisSunday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -0:7); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }

      function getNextMonday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? 1:8); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getNextTuesday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? 2:9); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getNextWednesday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? 3:10); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getNextThursday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? 4:11); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getNextFriday(d) {
        d = new Date(d);
        const day = d.getDay();
        const diff = d.getDate() - day + (day == 0 ? 5:12); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getNextSaturday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? 6:13); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }
      function getNextSunday(d) {
        d = new Date(d);
        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? 7:14); // adjust when day is sunday
        return new Date(d.setDate(diff));
      }

      function formatDate(date) {
        var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;

        return [year, month, day].join('-');
      }

      const breakingDate = getThisFriday(new Date());
      breakingDate.setHours(23);
      breakingDate.setMinutes(59);
      breakingDate.setSeconds(59);
      //console.log("breakingDate: " + breakingDate);

      let currentMonday;
      let currentTuesday;
      let currentWednesday;
      let currentThursday;
      let currentFriday;
      let currentSaturday;
      let currentSunday;
      let startDayCurrent;
      let endDayCurrent;
      let scopeDatesCurrent;
  
      let nextMonday;
      let nextTuesday;
      let nextWednesday;
      let nextThursday;
      let nextFriday;
      let nextSaturday;
      let nextSunday;
      let startDayNext;
      let endDayNext;
      let scopeDatesNext;

      function getDates() {
      
        currentMonday = formatDate(getThisMonday(new Date()));
        currentTuesday = formatDate(getThisTuesday(new Date()));
        currentWednesday = formatDate(getThisWednesday(new Date()));
        currentThursday = formatDate(getThisThursday(new Date()));
        currentFriday = formatDate(getThisFriday(new Date()));
        currentSaturday = formatDate(getThisSaturday(new Date()));
        currentSunday = formatDate(getThisSunday(new Date()));
        startDayCurrent = getThisMonday(new Date());
        startDayCurrent = startDayCurrent.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
        endDayCurrent = getThisSunday(new Date());
        endDayCurrent = endDayCurrent.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
        scopeDatesCurrent = startDayCurrent + ' - ' + endDayCurrent;
  
        nextMonday = formatDate(getNextMonday(new Date()));
        nextTuesday = formatDate(getNextTuesday(new Date()));
        nextWednesday = formatDate(getNextWednesday(new Date()));
        nextThursday = formatDate(getNextThursday(new Date()));
        nextFriday = formatDate(getNextFriday(new Date()));
        nextSaturday = formatDate(getNextSaturday(new Date()));
        nextSunday = formatDate(getNextSunday(new Date()));
        startDayNext = getNextMonday(new Date());
        startDayNext = startDayNext.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
        endDayNext = getNextSunday(new Date());
        endDayNext = endDayNext.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
        scopeDatesNext = startDayNext + ' - ' + endDayNext;
  
        // console.log('THIS WEEK');
        // console.log(currentMonday);
        // console.log(currentTuesday);
        // console.log(currentWednesday);
        // console.log(currentThursday);
        // console.log(currentFriday);
        // console.log(currentSaturday;
        // console.log(currentsunday);
        // console.log('NEXT WEEK');
        // console.log(nextMonday);
        // console.log(nextTuesday);
        // console.log(nextWednesday);
        // console.log(nextThursday);
        // console.log(nextFriday);
        // console.log(nextSaturday);
        // console.log(nextSunday);
  
        // console.log(scopeDatesCurrent);
        // console.log(scopeDatesNext);
  
        // if (today < breakingDate) {
  
        // } else {
  
        // }
      }

      getDates();

      function setToday() {
        // console.log("SETTING TODAY ACTIVE IN CURRENT WEEK");
        // console.log(formatDate(today));
        // console.log(currentMonday);
        if (formatDate(today) === currentMonday) {
          // console.log("TODAY IS MONDAY");
          $('#day-01-btn').addClass('today active');
          $('.poniedzialek.current').addClass('today active');
        } else if (formatDate(today) === currentTuesday) {
          // console.log("TODAY IS TUESDAY");
          $('#day-02-btn').addClass('today active');
          $('.wtorek.current').addClass('today active');
        } else if (formatDate(today) === currentWednesday) {
          // console.log("TODAY IS WEDNESDAY");
          $('#day-03-btn').addClass('today active');
          $('.sroda.current').addClass('today active');
        } else if (formatDate(today) === currentThursday) {
          // console.log("TODAY IS THURSDAY");
          $('#day-04-btn').addClass('today active');
          $('.czwartek.current').addClass('today active');
        } else if (formatDate(today) === currentFriday) {
          // console.log("TODAY IS FRIDAY");
          $('#day-05-btn').addClass('today active');
          $('.piatek.current').addClass('today active');
        } else if (formatDate(today) === currentSaturday) {
          // console.log("TODAY IS SATURDAY");
          $('#day-06-btn').addClass('today active');
          $('.sobota.current').addClass('today active');
        } else if (formatDate(today) === currentSunday) {
          // console.log("TODAY IS SUNDAY");
          $('#day-07-btn').addClass('today active');
          $('.niedziela.current').addClass('today active');
        }
      }
  
      setToday();

      // INSERT DATA
      $('.current-week-scope').html('<span class="label">aktualny tydzień</span><span>' + scopeDatesCurrent + '</span>');
      $('.next-week-scope').html('<span class="label">przyszły tydzień</span><span>' + scopeDatesNext + '</span>');

      // FUNKCJA SORTOWANIA
      function sortByKey(array, key) {
        return array.sort((a, b) => {
          let x = a[key];
          let y = b[key];

          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
      }

      // KONTENERY DIET
      const dietsContainer = $('.dieta-menu-set');
      const dietsArray = Object.entries(dietsContainer);
      //console.log(dietsArray);

      dietsArray.forEach(fillWeekMenu);

      // FUNKCJA WSTAWIANIA POSIŁKÓW
      function insertMenuData(data, currentMondayMenuContainer, currentTuesdayMenuContainer, currentWednesdayMenuContainer, currentThursdayMenuContainer, currentFridayMenuContainer, currentSaturdayMenuContainer, currentSundayMenuContainer, nextMondayMenuContainer, nextTuesdayMenuContainer, nextWednesdayMenuContainer, nextThursdayMenuContainer, nextFridayMenuContainer, nextSaturdayMenuContainer, nextSundayMenuContainer ) {
        //console.log('WSTAWIAM MENU:')
        // console.log('Success:', data);

        // CURRENT WEEK
        if (!(data[currentMonday] === undefined)) {
          const currentMondayMenu = sortByKey(data[currentMonday], 'priority');
          currentMondayMenu.forEach(printCurrentMondayMenu);
        } else {
          currentMondayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[currentTuesday] === undefined)) {
          const currentTuesdayMenu = sortByKey(data[currentTuesday], 'priority');
          currentTuesdayMenu.forEach(printCurrentTuesdayMenu);
        } else {
          currentTuesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[currentWednesday] === undefined)) {
          const currentWednesdayMenu = sortByKey(data[currentWednesday], 'priority');
          currentWednesdayMenu.forEach(printCurrentWednesdayMenu);
        } else {
          currentWednesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[currentThursday] === undefined)) {
          const currentThursdayMenu = sortByKey(data[currentThursday], 'priority');
          currentThursdayMenu.forEach(printCurrentThursdayMenu);
        } else {
          currentThursdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[currentFriday] === undefined)) {
          const currentFridayMenu = sortByKey(data[currentFriday], 'priority');
          currentFridayMenu.forEach(printCurrentFridayMenu);
        } else {
          currentFridayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[currentSaturday] === undefined)) {
          const currentSaturdayMenu = sortByKey(data[currentSaturday], 'priority');
          currentSaturdayMenu.forEach(printCurrentSaturdayMenu);
        } else {
          currentSaturdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[currentSunday] === undefined)) {
          const currentSundayMenu = sortByKey(data[currentSunday], 'priority');
          currentSundayMenu.forEach(printCurrentSundayMenu);
        } else {
          currentSundayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        // NEXT WEEK
        if (!(data[nextMonday] === undefined)) {
          const nextMondayMenu = sortByKey(data[nextMonday], 'priority');
          nextMondayMenu.forEach(printNextMondayMenu);
        } else {
          nextMondayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[nextTuesday] === undefined)) {
          const nextTuesdayMenu = sortByKey(data[nextTuesday], 'priority');
          nextTuesdayMenu.forEach(printNextTuesdayMenu);
        } else {
          nextTuesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[nextWednesday] === undefined)) {
          const nextWednesdayMenu = sortByKey(data[nextWednesday], 'priority');
          nextWednesdayMenu.forEach(printNextWednesdayMenu);
        } else {
          nextWednesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[nextThursday] === undefined)) {
          const nextThursdayMenu = sortByKey(data[nextThursday], 'priority');
          nextThursdayMenu.forEach(printNextThursdayMenu);
        } else {
          nextThursdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[nextFriday] === undefined)) {
          const nextFridayMenu = sortByKey(data[nextFriday], 'priority');
          nextFridayMenu.forEach(printNextFridayMenu);
        } else {
          nextFridayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[nextSaturday] === undefined)) {
          const nextSaturdayMenu = sortByKey(data[nextSaturday], 'priority');
          nextSaturdayMenu.forEach(printNextSaturdayMenu);
        } else {
          nextSaturdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        if (!(data[nextSunday] === undefined)) {
          const nextSundayMenu = sortByKey(data[nextSunday], 'priority');
          nextSundayMenu.forEach(printNextSundayMenu);
        } else {
          nextSundayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
        }

        // CURRENT WEEK
        function printCurrentMondayMenu(item) {
          currentMondayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printCurrentTuesdayMenu(item) {
          currentTuesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printCurrentWednesdayMenu(item) {
          currentWednesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printCurrentThursdayMenu(item) {
          currentThursdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printCurrentFridayMenu(item) {
          currentFridayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printCurrentSaturdayMenu(item) {
          currentSaturdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printCurrentSundayMenu(item) {
          currentSundayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }

        // NEXT WEEK
        function printNextMondayMenu(item) {
          nextMondayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printNextTuesdayMenu(item) {
          nextTuesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printNextWednesdayMenu(item) {
          nextWednesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printNextThursdayMenu(item) {
          nextThursdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printNextFridayMenu(item) {
          nextFridayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printNextSaturdayMenu(item) {
          nextSaturdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }
        function printNextSundayMenu(item) {
          nextSundayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
        }

      }

      function fillWeekMenu(item) {

        let dietContainer;
        let crmDietId;

        if (!($(item[1]).attr('data-crm-id') === undefined)) {
          dietContainer = $(item[1]);
          crmDietId = dietContainer.attr('data-crm-id');

          // // KONTENERY MENU DNIOWE - CURRENT WEEK
          const currentMondayMenuContainer = dietContainer.children('.poniedzialek.current');
          const currentTuesdayMenuContainer = dietContainer.children('.wtorek.current');
          const currentWednesdayMenuContainer = dietContainer.children('.sroda.current');
          const currentThursdayMenuContainer = dietContainer.children('.czwartek.current');
          const currentFridayMenuContainer = dietContainer.children('.piatek.current');
          const currentSaturdayMenuContainer = dietContainer.children('.sobota.current');
          const currentSundayMenuContainer = dietContainer.children('.niedziela.current');

          // // KONTENERY MENU DNIOWE - CURRENT WEEK
          const nextMondayMenuContainer = dietContainer.children('.poniedzialek.next');
          const nextTuesdayMenuContainer = dietContainer.children('.wtorek.next');
          const nextWednesdayMenuContainer = dietContainer.children('.sroda.next');
          const nextThursdayMenuContainer = dietContainer.children('.czwartek.next');
          const nextFridayMenuContainer = dietContainer.children('.piatek.next');
          const nextSaturdayMenuContainer = dietContainer.children('.sobota.next');
          const nextSundayMenuContainer = dietContainer.children('.niedziela.next');

          // console.log(currentMondayMenuContainer);
          // console.log(currentTuesdayMenuContainer);
          // console.log(currentWednesdayMenuContainer);
          // console.log(currentThursdayMenuContainer);
          // console.log(currentFridayMenuContainer);
          // console.log(currentSaturdayMenuContainer);
          // console.log(currentSundayMenuContainer);

          // console.log(nextMondayMenuContainer);
          // console.log(nextTuesdayMenuContainer);
          // console.log(nextWednesdayMenuContainer);
          // console.log(nextThursdayMenuContainer);
          // console.log(nextFridayMenuContainer);
          // console.log(nextSaturdayMenuContainer);
          // console.log(nextSundayMenuContainer);

          // GET THIS DIET MENU
          const stringToDecode = '{"dietId":' + crmDietId + ',"dates":["' + currentMonday + '","' + currentTuesday + '","' + currentWednesday + '","' + currentThursday + '","' + currentFriday + '","' + currentSaturday  + '","' + currentSunday + '","' + nextMonday + '","' + nextTuesday + '","' + nextWednesday + '","' + nextThursday + '","' + nextFriday + '","' + nextSaturday  + '","' + nextSunday + '"]}';
          let criteria = encodeURIComponent(stringToDecode)
          const apiUrl = 'https://dietly.pl/api/form/open/menus?searchCriteria=' + criteria;
          let data;

          fetch(apiUrl, {
            method: 'GET',
            headers: {
              'api-key': 'masterlife',
              'company-id': 'pysznafabryka',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then(response => response.json())
            .then(data => {

              //console.log('Success:', data);
              insertMenuData(data, currentMondayMenuContainer, currentTuesdayMenuContainer, currentWednesdayMenuContainer, currentThursdayMenuContainer, currentFridayMenuContainer, currentSaturdayMenuContainer, currentSundayMenuContainer, nextMondayMenuContainer, nextTuesdayMenuContainer, nextWednesdayMenuContainer, nextThursdayMenuContainer, nextFridayMenuContainer, nextSaturdayMenuContainer, nextSundayMenuContainer);

            })
            .catch((error) => {
              // console.error('Error:', error);
            });
        }

      }

    },
}
